import { Component, Input, OnInit } from '@angular/core';

import { PageBlock } from '../../common/services';


@Component({
  selector: 'p8-bdc-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss']
})
export class PageContentComponent implements OnInit {
  @Input() content: PageBlock[];

  constructor() { }

  ngOnInit() {
  }

}
